<p-tabs [value]="selectedTab.value" class="bg-green-100">
    <p-tablist>
        @for (tab of tabs; track tab.value) {
        <p-tab [value]="tab.value" (click)="onTabChange(tab)">
            <i class="pi pi-{{ tab.icon }} text-green-600"></i>
            {{ tab.title }}
        </p-tab>
        }
    </p-tablist>
    <p-tabpanels>
        @for (tab of tabs; track tab.value) {
        <p-tabpanel [value]="tab.value">
            @if(selectedTab.value === tab.value) {
            <ng-container *ngComponentOutlet="tab.content"></ng-container>
            }
        </p-tabpanel>
        }
    </p-tabpanels>
</p-tabs>